import { render, staticRenderFns } from "./FlowStepCancelSurveyEmpty.vue?vue&type=template&id=77c16886&"
import script from "./FlowStepCancelSurveyEmpty.vue?vue&type=script&lang=js&"
export * from "./FlowStepCancelSurveyEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports